import { useLiveResource } from "@lib/hooks/useLiveResource";

export function useCampaignChannel(campaignId: string, onUpdate: () => void) {
  useLiveResource({
    channel: "CampaignChannel",
    params: { campaign_id: campaignId },
    onInvalidate: onUpdate,
  });
}
